import(/* webpackMode: "eager" */ "/hisea-ssr/src/app/global-error.tsx");
